/**
 * 小店管理路由
 * @author Jerry
 * @since 2020-08-31 20:08:53
 */
export default [
    {
        path: 'shop',
        name: '商家管理',
        component: () => import('../pages/admin/shop/index.vue'),
        meta: {
            title: '商家管理',
            icon: 'money-collect',
            roles: ['small_shop_manage'],
        },
        children: [
            {
                path: 'list',
                name: '商家列表',
                component: () => import('../pages/admin/shop/merchant-list.vue'),
                meta: {
                    title: '商家列表',
                    roles: ['business_list'],
                },
            },
            {
                path: 'review',
                name: '商家审核',
                component: () => import('../pages/admin/shop/merchant-review.vue'),
                meta: {
                    title: '商家审核',
                    roles: ['business_audit'],
                },
            },
            /* // 商家资质
             {
               path: 'qualification',
               name: '商家资质',
               component: () => import('../pages/admin/shop/qualification/list.vue'),
               meta: {
                 title: '商家资质',
                 // 临时用下商家审核的 roles 字符串
                 // 正式版本需要切换
                 roles: ['business_audit'],
               },
             },
             // 资质审核
             {
               path: 'qualification_audit',
               name: '资质审核',
               component: () => import('../pages/admin/shop/qualification/audit.vue'),
               meta: {
                 title: '资质审核',
                 // 临时用下商家审核的 roles 字符串
                 // 正式版本需要切换
                 roles: ['business_audit'],
               },
             },*/
            {
                path: 'goods',
                name: '商品管理 ',
                component: () => import('../pages/admin/shop/goods-management.vue'),
                meta: {
                    title: '商品管理',
                    roles: ['shop_goods_manage'],
                },
            },
            {
                path: 'order',
                name: '订单管理',
                component: () => import('../pages/admin/shop/order-management.vue'),
                meta: {
                    title: '订单管理',
                    roles: ['order_manage'],
                },
            },
            {
                path: 'account',
                name: '账户管理',
                component: () => import('../pages/admin/shop/account-management.vue'),
                meta: {
                    title: '账户管理',
                    roles: ['shop_account_manage'],
                },
            },
            {
                path: 'settlement',
                name: '结算管理',
                component: () => import('../pages/admin/shop/settlement-management.vue'),
                meta: {
                    title: '结算管理',
                    roles: ['settle_accounts_manage'],
                },
            },
            {
                path: 'leadSettle',
                name: '导入结算单',
                hidden: true,
                component: () => import('../pages/admin/shop/leadSettle.vue'),
                meta: {
                    title: '结算单',
                    roles: ['settle_accounts_manage_import_statement'],
                },
            },
        ],
    },
    {
        path: 'shop_list',
        name: '小店列表 ',
        component: () => import('../pages/admin/shop/shop-management.vue'),
        meta: {
            title: '小店列表',
            icon: 'money-collect',
            roles: ['manage_small_shop_manage'],
        },
        children: [],
    },
];
//# sourceMappingURL=shop.js.map